import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';

import './style.scss';

export default function Loading() {
    const {authState, oktaAuth} = useOktaAuth();
    const [authenticated, setAuthenticated] = useState(null);

    useEffect(() => {
        const isAuthenticated = authState ? authState.isAuthenticated : false;
        if (isAuthenticated !== authenticated) {
            setAuthenticated(isAuthenticated);
        }
    });

    if (authenticated) {
        return null;
    }

    return (
        <div id="full-screen-container">
            <span>Loading...</span>
        </div>
    );
}